export const PERMISSIONS = {
  USERS_LIST: 'Users.ListAdminUsers',
  USERS_CREATE: 'Users.CreateAdminUser',
  USERS_EDIT: 'Users.EditAdminUser',
  USERS_TOGGLE: 'Users.ToggleAdminUserStatus',
  USERS_RESEND: 'Users.ResendAdminUserActivation',
  COUNTRIES_LIST: 'Countries.ListCountries',
  COUNTRIES_VIEW: 'Countries.ViewCountry',
  COUNTRIES_CREATE: 'Countries.CreateCountry',
  COUNTRIES_EDIT: 'Countries.EditCountry',
  COUNTRIES_TOGGLE: 'Countries.ToggleCountryStatus',
  COUNTRIES_DELETE: 'Countries.DeleteCountry',
  REGIONS_LIST: 'Regions.ListRegions',
  REGIONS_VIEW: 'Regions.ViewRegion',
  REGIONS_CREATE: 'Regions.CreateRegion',
  REGIONS_EDIT: 'Regions.EditRegion',
  REGIONS_TOGGLE: 'Regions.ToggleRegionStatus',
  REGIONS_DELETE: 'Regions.DeleteRegion',
  ROLES_CHANGE: 'Roles.ChangeAdminUserRole',
  SOURCES_LIST: 'Sources.ListSources',
  SOURCES_CREATE: 'Sources.CreateSource',
  SOURCES_EDIT: 'Sources.EditSource',
  SOURCES_TOGGLE: 'Sources.ToggleSourceStatus',
  SOURCES_DELETE: 'Sources.DeleteSource',
  SAAS_USERS_LIST: 'SaasUsers.ListSaasUsers',
  TENANTS_LIST: 'Tenants.ListTenants',
  TENANTS_VIEW: 'Tenants.ViewTenant',
  TENANTS_TOGGLE_STATUS: 'Tenants.ToggleTenantStatus',
  PLANS_MANAGE: 'Plans.ManagePlans',
  PLANS_ASSIGN_SPECIAL: 'Plans.AssignSpecialPlan',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
